module.exports = __webpack_public_path__ + "img/ctycxc.45665c70.png";